/**
 * Banner de plano limitado com CTA de upgrade.
 * Visível apenas nos planos GRATUITO e BÁSICO.
 */
import type { Plan } from '../types/api'

const PLAN_MESSAGES: Partial<Record<Plan, { text: string; cta: string }>> = {
  GRATUITO: {
    text: 'Você está no plano Gratuito — limite de 1 REP e 5 funcionários.',
    cta: 'Fazer upgrade →',
  },
  BÁSICO: {
    text: 'Plano Básico — até 3 REPs e 50 funcionários.',
    cta: 'Ver plano Profissional →',
  },
}

interface Props {
  plan: Plan
}

export function PlanBanner({ plan }: Props) {
  const msg = PLAN_MESSAGES[plan]
  if (!msg) return null

  return (
    <div
      style={{
        backgroundColor: 'var(--color-warning-light)',
        borderBottom: '1px solid #fcd34d',
        padding: 'var(--space-2) var(--space-6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: 'var(--font-size-sm)',
        color: 'var(--color-warning)',
      }}
    >
      <span>{msg.text}</span>
      <a
        href="/admin/billing"
        style={{ fontWeight: 600, color: 'var(--color-warning)', textDecoration: 'underline' }}
      >
        {msg.cta}
      </a>
    </div>
  )
}
